import './Pricing.css';

const PLANS = [
    {
        name: 'Starter',
        price: '€0',
        subtitle: 'Explore smarter matching.',
        features: [
            'Basic AI role matches',
            'Profile & resume upload',
            'Limited weekly recommendations',
            'Application tracker (lite)',
        ],
        cta: 'Start Free',
        featured: false,
    },
    {
        name: 'Pro',
        price: '€29',
        subtitle: 'Our most popular plan.',
        features: [
            'Unlimited AI matching',
            'Network & warm-intro insights',
            'Full application tracker',
            'Outreach & resume suggestions',
            'Priority support',
        ],
        cta: 'Go Pro',
        featured: true,
    },
    {
        name: 'Career+',
        price: '€79',
        subtitle: 'For a full search push',
        features: [
            'Everything in Pro',
            'Advanced company signals',
            'Personalized search strategy',
            'Monthly coaching check-in',
            'Early access to new features',
        ],
        cta: 'Join Career+',
        featured: false,
    },
];

function Pricing() {
    return (
        <section className="al-section" id="pricing">
            <div className="al-shell">
                <div className="al-section-head al-section-head--center">
                    <p className="al-eyebrow">Pricing</p>
                    <h2 className="al-display">
                        <span className="al-em">Plans</span> That Fit Your Search
                    </h2>
                </div>
                <div className="al-pricing-grid">
                    {PLANS.map((plan) => (
                        <article
                            className={`al-plan ${plan.featured ? 'al-plan--featured' : ''}`}
                            key={plan.name}
                        >
                            <h3 className="al-h3">{plan.name}</h3>
                            <p className="al-eyebrow">{plan.subtitle}</p>
                            <p className="al-price">
                                <span className="al-em">{plan.price}</span>
                                <span className="al-price-slash">/</span>
                                <span className="al-price-period">mo</span>
                            </p>
                            <ul>
                                {plan.features.map((feature) => (
                                    <li key={feature}>{feature}</li>
                                ))}
                            </ul>
                            <button className="al-btn al-btn--dark" type="button">{plan.cta}</button>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Pricing;
